<script setup lang="ts">
import type { HeroContactFragment } from '#graphql-operations'

interface ContactHeroProps {
  data: HeroContactFragment
}

const props = defineProps<ContactHeroProps>()

const colorScheme = useColorScheme(() => props.data.colorScheme)
const colors = useColorSchemeColors(() => props.data.colorScheme)

function openGoogleMaps() {
  const { lat, lng } = props.data.map ?? {}
  if (lat == null || lng == null)
    return
  window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank', 'noopener,noreferrer')
}
</script>

<template>
  <Section class="blockHero c-$color-scheme-foreground bg-$color-scheme-background grid lg:grid-cols-2" :class="colorScheme">
    <div class="px-3.75 py-5.5 flex flex-col h-full lg:px-18.5 lg:py-12 lg:space-y-15">
      <div class="flex-none">
        <div>
          <h1 class="typo-serif-4">
            <Text :html="data.heading" class="typo-serif-4" />
          </h1>
          <!-- <Text as="p" :text="`${treatment.title} ${$t('consultation')}`" class="typo-sans-1 uppercase" /> -->
          <Text v-if="data.description" :html="data.description" class="typo-serif-2" />
        </div>
      </div>
      <ul v-if="data.contactInformations.length > 0" class="flex-1 space-y-12 lt-lg:mt-12 lg:space-y-17">
        <li v-for="contactInformation in data.contactInformations" :key="contactInformation?.id" class="space-y-6">
          <Text v-if="contactInformation?.heading " as="h4" :html="contactInformation.heading" class="typo-sans-1 block uppercase" />
          <ul v-if="(contactInformation?.informations.length || 0) > 0" class="space-y-3 lg:space-y-4.5">
            <li v-for="information in contactInformation?.informations" :key="information?.id" class="flex">
              <Text :text="information?.title" class="typo-sans-1 flex-none max-w-48 w-full uppercase" />
              <Text :html="information?.description" class="typo-sans-1 uppercase" />
            </li>
          </ul>
        </li>
      </ul>
      <ul v-if="data.links" class="mt-18 flex flex-none gap-1.5 items-center lg:mt-10">
        <li v-for="linkItem in data.links" :key="linkItem!.id">
          <ButtonLink :link="linkItem?.customLink" />
        </li>
      </ul>
    </div>
    <BrandMap
      v-if="data.map?.lat != null && data.map?.lng != null && colors"
      :lat="data.map.lat"
      :lng="data.map.lng"
      :zoom="data.map.zoom"
      :foreground="colors.foreground"
      background="#ffffff"
      class="size-full min-h-35svh"
      @marker-click="openGoogleMaps"
    >
      <template #marker>
        <div class="p-1 rounded-full bg-white flex size-full items-center justify-center">
          <SiteSwitchComponent name="monogram" class="h-auto w-full" />
        </div>
      </template>
    </BrandMap>
  </Section>
</template>
